import React, { useEffect } from 'react';

import { cf } from './c_20210415a_YSh/cf';
import { ce } from './c_20210415a_YSh/ce';
import { iv } from './c_20210415a_YSh/iv';
import { ic } from './c_20210415a_YSh/ic';
import { cp } from './c_20210415a_YSh/cp';
import { ip } from './c_20210415a_YSh/ip';
import { bf } from './c_20210415a_YSh/bf';

import cView from './c_20210415a_YSh/cView';

// 基本的な処理の流れ
// sgc_pageKey が指定されている場合： 入席情報 -> 顧客情報 -> 注文情報
// バインダが指定されている場合： 顧客情報 -> 入席情報・注文情報
// 顧客情報 -> 入席情報 -> 顧客情報と循環が発生しないように注意
// 
// 想定する業務フロー
// １）入席情報の新規登録においてバインダを選択した際に、顧客情報が呼び出され、入席前となること（現時点）
// ２）入席情報の新規登録においてバインダを選択した際に、既存の顧客情報・入席情報が呼び出され、入席中となること（現時点）
// ３）既存の入席情報を表示した際に、入席中となり、退席済にできること（過去時点）
// ４）退席済の入席情報をQR表示した際に、再入席できること（現時点）
// ５）退席済の入席情報を通常表示した際に、際入席でいないこと（過去時点）

export default class iSrvDtl extends cView {

  constructor(props) { // state の宣言だけでは駄目な模様, global.c? は使用できない
    super(props);
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );

    // アラート時刻の取得
    bf.myCM_clw(60, () => { // コース終了時刻の確認を1分おきに実行
      if (this.state.sb_etr == true && this.state.sb_alert == false) { // 2回目以降は表示しない
        this._chk_it10d120()
        .then( _b_res => {
          if (_b_res) {
            this.setState({
              sb_alert: true,
            });
          };
        })
      }
      else {
        // alert('動作確認用：アラートを表示済です。')
      };
    });

    bf.myCM_clw(60, () => { // 1分おきに表示を更新
      if ( this.state.sb_etr == true && this.state.sgcd_pageModes[this.state.sgc_pageName] == 'show' ) {
        let _cnd = bf.q('[_KEY]={}'.f(this.state.sgcd_pageCmns?.it10_key));
        ip.$ip_hlr_it10({
          mode: 'get',
          cnd: _cnd,
        })
        .then( _d_is => {
          if ( _d_is.it10cy30 != this.state.s_it10cy30 ) {
            this.load();
          };
        });
      };
    });

/*
    cf.myLS_get('tkn').then((_tkn) => { // tkn が設定されていない場合　ログアウト
bf.l('67: {}'.f(_tkn))
      if (!bf.f(_tkn)) { // myRN_logout の場合 global.c? が指定されており正常に動作しない模様
bf.l('69: here'.f(_tkn))
        cf.myRN_logout();
      };
    });
*/
  }

  $id_stss = {
    //
//    sgcn_pageTab: 1,
    sgcn_pageTab: 3,
    //
    sld_im10ss: [], // バインダ一覧
    //
    sld_cm50ss: [], // コース一覧
    sld_cm50ss2: [], // 商品一覧
    //
    sdd_cm50ss: [], // 商品情報
    //
    sld_cm5tss: [], // 商品分類一覧
    //
    sld_it30ss: [], // 注文明細一覧
    //
    s_it10b21k: '', // バインダ
    s_it10s110: '0', // 接客状況
    s_it10d110: '', // 接客開始日時
    s_it10d120: '', // 接客終了日時
    s_it10i110: '0', // コース
    s_it10i530: '0', // 総時間
    s_it10i640: '0', // 総金額
    s_it10ia80: '0', // 支払額（30分延長時）
    s_it10ia90: '0', // 支払額（60分延長時）
    //
    s_it20s110: '-1', // 入席状況
    s_it20d110: '', // 入席開始日時
    s_it20d120: '', // 入席終了日時
    //
    s_cm5ii210: '0', // 30分延長料金
    s_cm5ii220: '0', // 60分延長料金
    //
    sb_etr: false,
    sb_alert: false, // コース終了のアラート表示
    //
    sb_qry: false, // QRコード経由での表示
    //
    s_dsp00: '',
    s_dsp30: '',
    s_dsp60: '',

    sld_it30Sortss: [
      { fld: 'it30cy10', dtn: 'desc', mode: 'str'}
    ],

    sld_it31ss: [
    ],
  };

  $ip_onEtr = () => new Promise( _o_end1 => {
    global.c?.setState({
      sb_etr: true,
    }, () => {
      _o_end1();
    })
  });

  $ip_onExit = () => new Promise( _o_end1 => {
    global.c?.setState({
      sb_etr: false,
    }, () => {
      _o_end1();
    })
  });

  $ilp_bfrLoads = () => [
/*
    new Promise( _o_end1 => {
      cp.$cp_load_cm10({ // スタッフ情報
        mode: 'items',
        b_wotDlt: true,
        state: 'sld_cm10ss',
        cnd: bf.q('[_KEY]>0'), // 他店舗や過去履歴の社員を表示するために必要
      })
      .then(() => {
        global.c?.setState({
          sld_cm10ss: bf.p(global.c?.state.sld_cm10ss, _next => {
            _next
            .map( (_d_cm10s, _idx) => {
              if (
                bf.n(_d_cm10s.val.cm10b21k) != bf.n(global.c?.state.sgcd_pageCmns?.cm20_key) ||
                bf.n(_d_cm10s.val.cm10cz10) != 10
              ) {
                _d_cm10s.b_hide = true;
              }
              else {
                _d_cm10s.b_hide = false;
              }
            })
          }),
        }, () => {
          _o_end1();
        });
      })
    }),
    cp.$cp_load_cm50({ // コース一覧
      mode: 'items',
      state: 'sld_cm50ss1',
      cnd: bf.q('[cm50b11k]="{}" AND [cm50t110] LIKE "1__" AND IFNULL([cm50cz10],"10")<>"0"'.f(
        global.c?.state.sgcd_pageCmns?.cm20_key,
      )),
    }),
    cp.$cp_load_cm50({ // 商品一覧
      mode: 'items',
      b_wotDlt: true,
      state: 'sld_cm50ss2',
      cnd: bf.q('[cm50b11k]="{}" AND [cm50t110] NOT LIKE "1__" AND IFNULL([cm50cz10],"10")<>"0"'.f(
        global.c?.state.sgcd_pageCmns?.cm20_key,
      )),
    }),
    ip.$ip_load_cm2i({ // 店舗情報（アラート時間・延長金額）
      mode: 'set',
      b_clr: false,
      cm20_key: global.c?.state.sgcd_pageCmns?.cm20_key,
    }),
    ip.$ip_load_im10({ // バインダ一覧
      mode: 'items',
      b_wotDlt: true,
      state: 'sld_im10ss',
      cm20_key: global.c?.state.sgcd_pageCmns?.cm20_key,
    }),
    new Promise( _o_end1 => { // 商品情報
      cf.myCB_call_slc({
        ctr: 'nlm',
        elm: 'cm50',
        n_dms: 3,
        cnd: bf.q('[cm50b11k]="{}"'.f(
          global.c?.state.sgcd_pageCmns.cm20_key,
        )),
        do_rfrs: {
          cm5i: _d_is => bf.q('[cm5ib11k]="{}"'.f(_d_is._KEY)),
        }
      })
      .then( _ld_cm50ss => {
        let _d = {};
        _ld_cm50ss
        .map( _d_cm50s => {
          _d[_d_cm50s._KEY] = _d_cm50s;
        });
        global.c?.setState({
          sdd_cm50ss: _d,
        }, () => {
          _o_end1();       
        });
      })
    }),
*/
  ];

  $ilp_loads = () => [
    new Promise( _o_end1 => { // 指定したバインダに紐づく入席情報を生成
      let _d_prms = cf.myNV_get_prms();
      if (bf.f(_d_prms.im10_key)) { // QR読込の場合　：　バインダに紐づく顧客情報・入席情報を反映（現時点の情報）
bf.l('227: {}'.f(_d_prms.im10_key))
        global.c?.setState({
          sb_qr: true,
        }, () => {
          global.c?.setState({
            sgc_pageRole: (bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['80', '90'])) ? 'own3' : 'cast',
            sgc_pageName: 'iSrvDtl',
            s_it10b21k: _d_prms.im10_key,
          }, () => {
            global.c?._onChgIt10b21k()
            .then(() => {
//bf.l('238: here')
              _o_end1();
            });
          });
        });
      }
      else { // QR読込でない場合　：　入席情報に紐づく顧客情報を反映（過去時点の情報）
//bf.l('244: here')
        global.c?.setState({
          sb_qr: false,
        }, () => {
          ip.$ip_load_it20({
            mode: 'set',
            it20_key: global.c?.state.sgcd_pageCmns?.it20_key ?? -1,
          })
          .then( _d_it20s => {
            if (bf.f(_d_it20s) == false) { // 入席情報が存在しない場合
              alert('入席情報を確認できませんでした。');
              cf.myLS_setStt('sgcd_pageModes', bf.p(global.c?.state.sgcd_pageModes, _next => {
                _next['iSrvList'] = 'show';
              }))
              .then(() => {
                let _d_pageInfs = {
                  sgc_pageName: 'iSrvList',
                  sgc_pageRole: global.c?.state.sgc_pageRole,
                };
                cf.myRN_move_fwd(_d_pageInfs)
                .then(() => {
//bf.l('266: here')
                  _o_end1();
                });
              });
            }
            else {

/*
              ip.$ip_load_it10({
                mode: 'set',
                it10_key: global.c?.state.s_it20b11k,
              })
              .then(() => {
                cf.myRN_setCmns({ // 別店舗の店舗運営者が注文情報を登録する場合に対応するため、入店情報の店舗と同期を取る
                  cm20_key: bf.f(global.c?.state.s_it10b11k) ? global.c?.state.s_it10b11k : global.c?.state.sgcd_pageCmns.cm20_key,
                })
                .then(() => {

                  cp.$cp_hlr_cm10({
                    mode: 'get',
                    cnd: bf.q(`
                      [cm10b21k]="{}" AND 
                      [cm10i110]=(
                        SELECT
                          [cm10i110]
                        FROM
                          [t_cm10]
                        WHERE
                          [_KEY]={}
                      ) AND
                      IFNULL([cm10cz10],"10")<>"0"
                    `.f(
                      global.c?.state.sgcd_pageCmns.cm20_key,
                      global.c?.state.sgcd_pageCmns.cm10_key,
                    ))
                  })
                  .then( _d_cm10s => {
                    if (bf.f(_d_cm10s) == false) { // ユーザが cm20_key に登録されてない場合
                      alert('バインダの店舗においてユーザを確認できませんでした。');
                      cf.myLS_setStt('sgcd_pageModes', bf.p(global.c?.state.sgcd_pageModes, _next => {
                        _next['iSrvList'] = 'show';
                      }))
                      .then(() => {
                        let _d_pageInfs = {
                          sgc_pageName: 'iSrvList',
                          sgc_pageRole: global.c?.state.sgc_pageRole,
                        };
                        cf.myRN_move_fwd(_d_pageInfs)
                        .then(() => {
                          _o_end1();
                        });
                      });
                    }
                    else { // ユーザが cm20_key に登録されている場合
                      Promise.all([

                        ip.$ip_load_it30({ // 注文情報の反映 // エラーが発生した場合は t_it31 が生成されていることを確認
                          mode: 'clds',
                          state: 'sld_it30ss',
                          it10_key: global.c?.state.s_it20b11k,
                        }),

                        new Promise( _o_end2 => {
                          cp.$cp_load_cm10({ // スタッフ情報
                            mode: 'items',
                            b_wotDlt: true,
                            state: 'sld_cm10ss',
                            cnd: bf.q('[_KEY]>0'), // 他店舗や過去履歴の社員を表示するために必要
                          })
                          .then(() => {
                            global.c?.setState({
                              sld_cm10ss: bf.p(global.c?.state.sld_cm10ss, _next => {
                                _next
                                .map( (_d_cm10s, _idx) => {
                                  if (
                                    bf.n(_d_cm10s.val.cm10b21k) != bf.n(global.c?.state.sgcd_pageCmns?.cm20_key) ||
                                    bf.n(_d_cm10s.val.cm10cz10) != 10
                                  ) {
                                    _d_cm10s.b_hide = true;
                                  }
                                  else {
                                    _d_cm10s.b_hide = false;
                                  }
                                })
                              }),
                            }, () => {
                              _o_end2();
                            });
                          })
                        }),
                        cp.$cp_load_cm50({ // コース一覧
                          mode: 'items',
                          state: 'sld_cm50ss1',
                          cnd: bf.q('[cm50b11k]="{}" AND [cm50t110] LIKE "1__" AND IFNULL([cm50cz10],"10")<>"0"'.f(
                            global.c?.state.sgcd_pageCmns?.cm20_key,
                          )),
                        }),
                        cp.$cp_load_cm50({ // 商品一覧
                          mode: 'items',
                          b_wotDlt: true,
                          state: 'sld_cm50ss2',
                          cnd: bf.q('[cm50b11k]="{}" AND [cm50t110] NOT LIKE "1__" AND IFNULL([cm50cz10],"10")<>"0"'.f(
                            global.c?.state.sgcd_pageCmns?.cm20_key,
                          )),
                        }),
                        ip.$ip_load_cm2i({ // 店舗情報（アラート時間・延長金額）
                          mode: 'set',
                          b_clr: false,
                          cm20_key: global.c?.state.sgcd_pageCmns?.cm20_key,
                        }),
                        ip.$ip_load_im10({ // バインダ一覧
                          mode: 'items',
                          b_wotDlt: true,
                          state: 'sld_im10ss',
                          cm20_key: global.c?.state.sgcd_pageCmns?.cm20_key,
                        }),
                        new Promise( _o_end2 => { // 商品情報
                          cf.myCB_call_slc({
                            ctr: 'nlm',
                            elm: 'cm50',
                            n_dms: 3,
                            cnd: bf.q('[cm50b11k]="{}"'.f(
                              global.c?.state.sgcd_pageCmns.cm20_key,
                            )),
                            do_rfrs: {
                              cm5i: _d_is => bf.q('[cm5ib11k]="{}"'.f(_d_is._KEY)),
                            }
                          })
                          .then( _ld_cm50ss => {
                            let _d = {};
                            _ld_cm50ss
                            .map( _d_cm50s => {
                              _d[_d_cm50s._KEY] = _d_cm50s;
                            });
                            global.c?.setState({
                              sdd_cm50ss: _d,
                            }, () => {
                              _o_end2();       
                            });
                          })
                        }),

                      ])
                      .then(() => {
                        _o_end1();
                      });
                    };
                  });
                });
              });
*/
              ip.op_loadAll({
                b_clr: (global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName] == 'new') ? true : false,
                cnd: bf.q(`[_KEY]={}`.f(global.c?.state.s_it20b11k)),
              })
              .then( () => {
//bf.l('422: here')
                  _o_end1();
              })
            };
          });
//          };
        });
      };
    }),
  ];

/*
  _onChgIt10b21k = () => new Promise( _o_end1 => { // upd it20
    if (bf.n(global.c?.state.s_it10b21k) >= 1) { // バインダが設定されている場合
      let _now = bf.myDT_get_now();
      let _cnd = bf.q('[it10b21k]="{}" AND [it10d110]<="{}" AND [it10s110]="10"'.f( // 同一のバインダが重複して開いていることはない前提
        global.c?.state.s_it10b21k,
        _now,
        _now,
      ))
      ip.$ip_load_it10({ // 顧客情報の反映
        mode: 'set',
        cnd: _cnd,
      })
      .then( _d_it10s => {

        if (bf.f(_d_it10s)) { // バインダに紐づく顧客情報が存在する場合
          cf.myRN_setCmns({ // 別店舗の店舗運営者が注文情報を登録する場合に対応するため、入店情報の店舗と同期を取る
            cm20_key: bf.f(global.c?.state.s_it10b11k) ? global.c?.state.s_it10b11k : global.c?.state.sgcd_pageCmns.cm20_key,
          })
          .then(() => {

            ip.$ip_load_it30({ // 注文情報の反映
              mode: 'clds',
              state: 'sld_it30ss',
              it10_key: global.c?.state.s_it10_key,
            })
            .then(() => {

              ip.$ip_load_it20({ // 入席情報の反映
                mode: 'set',
                it10_key: _d_it10s._KEY,
                cm10_key: global.c?.state.sgcd_pageCmns?.cm10_key,
              })
              .then( _d_it20s => {

                if (bf.f(_d_it20s)) { // 顧客情報に紐づく入席情報が存在する場合
                  cf.myRN_setCmns({
                    it20_key: _d_it20s._KEY,
                  })
                  .then(() => {
                    cf.myLS_setStt('sgcd_pageModes', bf.p(global.c?.state.sgcd_pageModes, _next => {
                      _next[global.c?.state.sgc_pageName] = 'show';
                    }))
                    .then(() => {
                      _o_end1();
                    });
                  });
                }
                else { // 顧客情報に紐づく入席情報が存在しない場合
                  cf.myLS_setStt('sgcd_pageModes', bf.p(global.c?.state.sgcd_pageModes, _next => {
                    _next[global.c?.state.sgc_pageName] = 'new';
                  }))
                  .then(() => {
                    global.c?.setState({
                      s_it20s110: '0',
                    }, async () => {
                      await global.c?._onPrsStt(); // 即入席とする
                      _o_end1();
                    });
                  });
                };
              });
            });
          });
        }
        else { // バインダに紐づく顧客情報が存在しない場合
          alert('バインダに対応する顧客情報を確認できませんでした。');
          cf.myLS_setStt('sgcd_pageModes', bf.p(global.c?.state.sgcd_pageModes, _next => {
            _next['iSrvList'] = 'show';
          }))
          .then(() => {
bf.l('427:here') // これがないとエラーが発生
            let _d_pageInfs = {
              sgc_pageName: 'iSrvList',
              sgc_pageRole: global.c?.state.sgc_pageRole,
            };
            cf.myRN_move_fwd(_d_pageInfs);
            _o_end1();
          });
        };
      });
    }
    else {
      _o_end1();
    };
  });
*/
  _onChgIt10b21k = () => new Promise( _o_end1 => { // upd it20
//bf.l('525: here')
    if (bf.n(global.c?.state.s_it10b21k) < 1) { // バインダが設定されてない場合
      _o_end1();
    }
    else {// バインダが設定されている場合
      let _now = bf.myDT_get_now();
      let _cnd = bf.q('[it10b21k]="{}" AND [it10d110]<="{}" AND [it10s110]="10"'.f( // 同一のバインダが重複して開いていることはない前提
        global.c?.state.s_it10b21k,
        _now,
        _now,
      ))

/*
      ip.$ip_load_it10({ // 顧客情報の反映
        mode: 'set',
        cnd: _cnd,
      })
      .then( _d_it10s => {
*/

/*
        if (bf.f(_d_it10s) == false) { // バインダに紐づく顧客情報が存在しない場合
          alert('バインダに対応する顧客情報を確認できませんでした。');
          cf.myLS_setStt('sgcd_pageModes', bf.p(global.c?.state.sgcd_pageModes, _next => {
            _next['iSrvList'] = 'show';
          }))
          .then(() => {
            let _d_pageInfs = {
              sgc_pageName: 'iSrvList',
              sgc_pageRole: global.c?.state.sgc_pageRole,
            };
            cf.myRN_move_fwd(_d_pageInfs)
            .then(() => {
              _o_end1();
            });
          });
        }
        else { // バインダに紐づく顧客情報が存在する場合
          cf.myRN_setCmns({ // 別店舗の店舗運営者が注文情報を登録する場合に対応するため、入店情報の店舗と同期を取る
            cm20_key: bf.f(global.c?.state.s_it10b11k) ? global.c?.state.s_it10b11k : global.c?.state.sgcd_pageCmns.cm20_key,
          })
          .then(() => {
            cp.$cp_hlr_cm10({
              mode: 'get',
              cnd: bf.q(`
                [cm10b21k]="{}" AND 
                [cm10i110]=(
                  SELECT
                    [cm10i110]
                  FROM
                    [t_cm10]
                  WHERE
                    [_KEY]={}
                ) AND
                IFNULL([cm10cz10],"10")<>"0"
              `.f(
                global.c?.state.sgcd_pageCmns.cm20_key,
                global.c?.state.sgcd_pageCmns.cm10_key,
              ))
            })
            .then( _d_cm10s => {
              if (bf.f(_d_cm10s) == false) { // ユーザが cm20_key に登録されてない場合
                alert('バインダの店舗においてユーザを確認できませんでした。');
                cf.myLS_setStt('sgcd_pageModes', bf.p(global.c?.state.sgcd_pageModes, _next => {
                  _next['iSrvList'] = 'show';
                }))
                .then(() => {
                  let _d_pageInfs = {
                    sgc_pageName: 'iSrvList',
                    sgc_pageRole: global.c?.state.sgc_pageRole,
                  };
                  cf.myRN_move_fwd(_d_pageInfs)
                  .then(() => {
                    _o_end1();
                  });
                });
              }
              else { // ユーザが cm20_key に登録されている場合
                Promise.all([

                  new Promise( _o_end2 => {
                    ip.$ip_load_it20({ // 入席情報の反映
                      mode: 'set',
                      cnd: bf.q(`
                        [it20b11k]="{}" AND 
                        [it20b21k]="{}"
                      `.f(
                        _d_it10s._KEY,
                        global.c?.state.sgcd_pageCmns?.cm10_key,
                      )),
                    })
                    .then( _d_it20s => {
                      if (bf.f(_d_it20s)) { // 顧客情報に紐づく入席情報が存在する場合
                        cf.myRN_setCmns({
                          it20_key: _d_it20s._KEY,
                        })
                        .then(() => {
                          cf.myLS_setStt('sgcd_pageModes', bf.p(global.c?.state.sgcd_pageModes, _next => {
                            _next[global.c?.state.sgc_pageName] = 'show';
                          }))
                          .then(() => {
                            _o_end2();
                          });
                        });
                      }
                      else { // 顧客情報に紐づく入席情報が存在しない場合
                        cf.myLS_setStt('sgcd_pageModes', bf.p(global.c?.state.sgcd_pageModes, _next => {
                          _next[global.c?.state.sgc_pageName] = 'new';
                        }))
                        .then(() => {
                          global.c?.setState({
                            s_it20s110: '0',
                          }, async () => {
                            await global.c?._onPrsStt(); // 即入席とする
                            _o_end2();
                          });
                        });
                      };
                    });
                  }),

                  ip.$ip_load_it30({ // 注文情報の反映
                    mode: 'clds',
                    state: 'sld_it30ss',
                    it10_key: global.c?.state.s_it10_key,
                  }),

                  new Promise( _o_end2 => {
                    cp.$cp_load_cm10({ // スタッフ情報
                      mode: 'items',
                      b_wotDlt: true,
                      state: 'sld_cm10ss',
                      cnd: bf.q('[_KEY]>0'), // 他店舗や過去履歴の社員を表示するために必要
                    })
                    .then(() => {
                      global.c?.setState({
                        sld_cm10ss: bf.p(global.c?.state.sld_cm10ss, _next => {
                          _next
                          .map( (_d_cm10s, _idx) => {
                            if (
                              bf.n(_d_cm10s.val.cm10b21k) != bf.n(global.c?.state.sgcd_pageCmns?.cm20_key) ||
                              bf.n(_d_cm10s.val.cm10cz10) != 10
                            ) {
                              _d_cm10s.b_hide = true;
                            }
                            else {
                              _d_cm10s.b_hide = false;
                            }
                          })
                        }),
                      }, () => {
                        _o_end2();
                      });
                    })
                  }),
                  cp.$cp_load_cm50({ // コース一覧
                    mode: 'items',
                    state: 'sld_cm50ss1',
                    cnd: bf.q('[cm50b11k]="{}" AND [cm50t110] LIKE "1__" AND IFNULL([cm50cz10],"10")<>"0"'.f(
                      global.c?.state.sgcd_pageCmns?.cm20_key,
                    )),
                  }),
                  cp.$cp_load_cm50({ // 商品一覧
                    mode: 'items',
                    b_wotDlt: true,
                    state: 'sld_cm50ss2',
                    cnd: bf.q('[cm50b11k]="{}" AND [cm50t110] NOT LIKE "1__" AND IFNULL([cm50cz10],"10")<>"0"'.f(
                      global.c?.state.sgcd_pageCmns?.cm20_key,
                    )),
                  }),
                  ip.$ip_load_cm2i({ // 店舗情報（アラート時間・延長金額）
                    mode: 'set',
                    b_clr: false,
                    cm20_key: global.c?.state.sgcd_pageCmns?.cm20_key,
                  }),
                  ip.$ip_load_im10({ // バインダ一覧
                    mode: 'items',
                    b_wotDlt: true,
                    state: 'sld_im10ss',
                    cm20_key: global.c?.state.sgcd_pageCmns?.cm20_key,
                  }),
                  new Promise( _o_end2 => { // 商品情報
                    cf.myCB_call_slc({
                      ctr: 'nlm',
                      elm: 'cm50',
                      n_dms: 3,
                      cnd: bf.q('[cm50b11k]="{}"'.f(
                        global.c?.state.sgcd_pageCmns.cm20_key,
                      )),
                      do_rfrs: {
                        cm5i: _d_is => bf.q('[cm5ib11k]="{}"'.f(_d_is._KEY)),
                      }
                    })
                    .then( _ld_cm50ss => {
                      let _d = {};
                      _ld_cm50ss
                      .map( _d_cm50s => {
                        _d[_d_cm50s._KEY] = _d_cm50s;
                      });
                      global.c?.setState({
                        sdd_cm50ss: _d,
                      }, () => {
                        _o_end2();       
                      });
                    })
                  }),

                ])
                .then(() => {
                  _o_end1();
                });
              };
            })
          });
*/
//        let _cnd = bf.q(`[_KEY]={}`.f(global.c?.state.s_it20b11k));
//        let _cnd = bf.q(`[_KEY]={}`.f(global.c?.state.s_it10b21k));
//bf.l('737: {}'.f(_cnd))
        ip.op_loadAll({
          cnd: _cnd,
        })
        .then( _n_rs => {
//bf.l('742: here')
          if ( _n_rs == -2 ) { // 入店時刻情報が存在しない
//bf.l('737: here')
            alert('バインダに対応する顧客情報を確認できませんでした。');
            let _d_pageInfs =  iv.get_iniPageInfs(global.c?.state.sgcd_pageModes.user_key, global.c?.state.sgcd_pageModes.userc410);
            cf.myLS_setStt('sgcd_pageModes', bf.p(global.c?.state.sgcd_pageModes, _next => {
//                _next['iSrvList'] = 'show';
              _next[_d_pageInfs.sgc_pageName] = 'show';
            }))
            .then(() => {
              let _d_pageInfs = {
//                  sgc_pageName: 'iSrvList',
                sgc_pageName: _d_pageInfs.sgc_pageName,
                sgc_pageRole: global.c?.state.sgc_pageRole,
              };
              cf.myRN_move_fwd(_d_pageInfs)
              .then(() => {
//bf.l('752: here')
                _o_end1();
              });
            });
          };
          if ( _n_rs == 1 ) { // 入店時刻情報が存在し、対応する店舗にユーザが存在する場合
//bf.l('758: here')
            ip.$ip_load_it20({ // 入席情報の反映
              mode: 'set',
              cnd: bf.q(`
                [it20b11k]="{}" AND 
                [it20b21k]="{}"
              `.f(
                global.c?.state.sgcd_pageCmns?.it10_key,
                global.c?.state.sgcd_pageCmns?.cm10_key,
              )),
            })
            .then( _d_it20s => {
              if (bf.f(_d_it20s)) { // 顧客情報に紐づく入席情報が存在する場合
bf.l('783: {}, {}'.f(global.c?.state.sb_qr, _d_it20s))
                cf.myRN_setCmns({
                  it20_key: _d_it20s._KEY,
                })
                .then(() => {
                  cf.myLS_setStt('sgcd_pageModes', bf.p(global.c?.state.sgcd_pageModes, _next => {
                    _next[global.c?.state.sgc_pageName] = 'show';
                  }))
                  .then( async () => {
//bf.l('779: here')
//                    await global.c?._onPrsReStt(); // 即再入席とする
                    if (_d_it20s.it20s110 == '20') await global.c?._onPrsReStt(); // 退席済の場合、即再入席とする
                    _o_end1();
                  });
                });
              }
              else { // 顧客情報に紐づく入席情報が存在しない場合
                cf.myLS_setStt('sgcd_pageModes', bf.p(global.c?.state.sgcd_pageModes, _next => {
                  _next[global.c?.state.sgc_pageName] = 'new';
                }))
                .then(() => {
                  global.c?.setState({
                    s_it20s110: '0',
                  }, async () => {
                    await global.c?._onPrsStt(); // 即入席とする
//bf.l('793: here')
                    _o_end1();
                  });
                });
              };
            });
          };
        });
    };
//    };
  });

  _chk_it10d120 = () => new Promise( _o_end1 => {
      let _dff = bf.myDT_get_dff('mnt', bf.myDT_get_now(), global.c?.state.s_it10d120);
      if (
        _dff <= bf.n(global.c?.state.s_cm2ii110) && // アラート時間以内
        global.c?.state.s_it20s110 == '10' // 入席中
      ) {
/*
        alert('終了時刻{}分前を過ぎました。延長またはドリンクの確認をお願いします。'.f(
          global.c?.state.s_cm2ii110, 
        ));
*/
        global.c?.setState({
          sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next =>{
            _next.msg.b_showMdl = true;
          }),
        });
        _o_end1(true);
      }
      else {
        _o_end1(false);
      };
  });

  $ip_ins = () => ip.$ip_ins_it20();

  $ilp_upds = () => [
    ip.$ip_upd_it20(),
    new Promise( _o_end1 => {
      // 注文情報
      ip.$ip_ups_it30({
        cm10_key: global.c?.state.sgcd_pageCmns?.cm10_key,
      })
      .then(() => {
        cf.myCB_callQrys({
          l_tgts: [
            'it10d120', // 終了時刻 ※ it30 関係あり
            'it10ia70', // 支払総額 ※ it30 関係あり
            'it31i130', // 貢献度 ※ it30 関係あり
          ],
          dd_qryss: ip.dd_qryss,
          d_vals: {
            it60_key: global.c?.state.s_it50b21k,
            it50_key: global.c?.state.s_it10b31k,
            it10_key: global.c?.state.sgcd_pageCmns?.it10_key,
          },
        })
        .then(() => {
          _o_end1();
        });
      }); 
    }),
  ];

  $pdo_onChgs = () => ({
    s_it10i110: () => {
      ip._updCm50();
      ip._updCm5i();
    },
    s_cm5ii210: () => ip._updIt10ia80,
    s_cm5ii220: () => ip._updIt10ia90,
    s_it10d120: () => {
      ip._updDsp00();
      ip._updIt10d130();
      ip._updIt10d140();
    },
    s_it10d130: () => ip._updDsp30,
    s_it10d140: () => ip._updDsp60,
    s_it10ia70: () => {
      ip._updDsp00();
      ip._updIt10ia80();
      ip._updIt10ia90();
    },
    s_it10ia80: () => ip._updDsp30,
    s_it10ia90: () => ip._updDsp60,
  }); // app module change

  _onPrsStt = () => new Promise( _o_end1 => { // 入席
    const _d_vals = {
      it20s110: '20', // 入席状況
      it20d120: bf.myDT_get_now(), // 入席終了日時
    };
    const _cnd = bf.q(`
      [it20b21k] IN (
        SELECT
          [_KEY]::TEXT
        FROM
          [t_cm10]
        WHERE
          [cm10i110]=(
            SELECT
              [cm10i110]
            FROM
              [t_cm10]
            WHERE
              [_KEY]={}
          )
      ) AND 
      IFNULL([it20s110],"10")="10"
    `.f(
      global.c?.state.sgcd_pageCmns.cm10_key,
    ));
    cf.myCB_call_iud({ // 他の入席情報を退席済とする
      ctr: 'upd',
      elm: 'it20',
      d_vals: _d_vals,
      cnd: _cnd,
    })
    .then(() => {
      global.c?.setState({
        s_it20s110: '10', // 入席状況
        s_it20d110: bf.myDT_get_now(),
        s_it20d120: bf.maxDtm, // 入席終了日時
      }, () => {
        if (global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName] == 'new') { // 新規の場合
          global.c?.ins();
          _o_end1();
        }
        else { // 既存の場合
          global.c?.upd();
          _o_end1();
        }
      });    
    });
  });

/*
  _onPrsEnd = () => { // 退席
    global.c?.setState({
      s_it20s110: '20', // 接客状況
      s_it20d120: bf.myDT_get_now(), // 接客終了日時
    }, () => {
      global.c?.upd();
    });
  };
*/
  _onPrsEnd = () => { // upd した場合、load し、際入席するため、即退席
    let _d = {
      it20s110: '20', // 接客状況
      it20d120: bf.myDT_get_now(), // 接客終了日時
    };
    let _cnd = bf.q('[_KEY]={}'.f(global.c?.state.sgcd_pageCmns?.it20_key))
    cf.myCB_call_iud({ // 他の入席情報を退席済とする
      ctr: 'upd',
      elm: 'it20',
      d_vals: _d,
      cnd: _cnd,
    })
    .then(() => {
      let _d_pageInfs = {
        sgc_pageName: 'iSrvList',
        sgc_pageRole: global.c?.state.sgc_pageRole,
      };
      cf.myRN_move_fwd(_d_pageInfs)
    })
  };

/*
  _onPrsReStt = () => { // 再入席
    const _d_vals = {
      it20s110: '20', // 入席状況
      it20d120: bf.myDT_get_now(), // 入席終了日時
    }
    const _cnd = bf.q('[it20b21k]="{}" AND IFNULL([it20s110],"10")="10"'.f(
      global.c?.state.sgcd_pageCmns.cm10_key,
    ));
    cf.myCB_call_iud({ // 他の入席情報を退席済とする
      ctr: 'upd',
      elm: 'it20',
      d_vals: _d_vals,
      cnd: _cnd,
    })
    .then(() => {
      global.c?.setState({
        s_it20s110: '10', // 接客状況
        s_it20d120: bf.maxDtm, // 接客終了日時
      }, () => {
        global.c?.upd();
      });
    });
  };
*/
  _onPrsReStt = () => new Promise( _o_end1 => { // 再入席
    const _d_vals = {
      it20s110: '20', // 入席状況
      it20d120: bf.myDT_get_now(), // 入席終了日時
    }
    const _cnd = bf.q('[it20b21k]="{}" AND IFNULL([it20s110],"10")="10"'.f(
      global.c?.state.sgcd_pageCmns.cm10_key,
    ));
    cf.myCB_call_iud({ // 他の入席情報を退席済とする
      ctr: 'upd',
      elm: 'it20',
      d_vals: _d_vals,
      cnd: _cnd,
    })
    .then(() => {
      global.c?.setState({
        s_it20s110: '10', // 接客状況
        s_it20d120: bf.maxDtm, // 接客終了日時
      }, () => {
        global.c?.upd();
        _o_end1();
      });
    });
  });

  _onPrsSosStt = () => { // SOS 登録
    global.c?.setState({
      s_it10s210: '10', // 接客状況
    }, () => {
      const _d_vals = {
        it10s210: '10', // 入席状況
      }
      const _cnd = bf.q('[_KEY]={}'.f(
        global.c?.state.s_it20b11k, 
      ));
      cf.myCB_call_iud({ // 他の入席情報を退席済とする
        ctr: 'upd',
        elm: 'it10',
        d_vals: _d_vals,
        cnd: _cnd,
      })
    });
  };

  _onPrsSosEnd = () => { // SOS 解除
    global.c?.setState({
      s_it10s210: '0', // 接客状況
    }, () => {
      const _d_vals = {
        it10s210: '0', // 入席状況
      }
      const _cnd = bf.q('[_KEY]={}'.f(
        global.c?.state.s_it20b11k, 
      ));
      cf.myCB_call_iud({ // 他の入席情報を退席済とする
        ctr: 'upd',
        elm: 'it10',
        d_vals: _d_vals,
        cnd: _cnd,
      })
    });
  };

  $cld_onChgss = ip.ild_onChgss;

  $ild_onChgss = () => [
  ];

  render() {
    return (
      <this.$onChg>
      <ce.RootDtl
        key={-1}
        b_logo={false}
        b_rhtVsb={(global.c?.state.s_it20s110 == '10' && global.c?.state.sgcn_pageTab == 2) ? true : false}
        rhtPfx={null}
        rhtIconName={null} 
        onRhtPrs={null}
        onEditPrs={() => {
          if (global.c?.state.sgcn_pageTab == 2) {
            global.c?.setState({
              sgcb_srlToEnd: true,
            });
          };
        }}
        d_hdrs={{
          pfx:  iv._get_hdrPfx('入席情報'),
          d_leftBtns: iv._get_leftBtns(global.c?.state.sgc_pageRole, cf.myNV_get_name(), global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName]),
          d_subMenus: {
            b_vsb: (global.c?.state.sgcn_pageTab == 2) ? true : false,
            ld_iss: [
              {
                pfx: '登録日時で並び替え',
                onPrs: () => {
                  global.c?.setState({
                    sld_it30Sortss: [
                      { fld: 'it30cy10', dtn: 'desc', mode: 'str'}
                    ],
                  });
                },
              },
              {
                pfx: '商品で並び替え',
                onPrs: () => {
                  global.c?.setState({
                    sld_it30Sortss: [
                      { fld: 'cm50cx10', dtn: 'asc', mode: 'nmb'},
                      { fld: 'cm50_key', dtn: 'asc', mode: 'nmb'}
                    ],
                  });
                },
              },
              {
                pfx: '登録者で並び替え', // 登録者？
                onPrs: () => {
                  global.c?.setState({
                    sld_it30Sortss: [
                      { fld: 'cm1ii110', dtn: 'asc', mode: 'nmb'},
//                      { fld: 'it30cy20', dtn: 'asc', mode: 'nmb'}
//                      { fld: 'it30b21k', dtn: 'asc', mode: 'nmb'}
                      { fld: 'cm1ib11k', dtn: 'asc', mode: 'nmb'},
                    ],
                  });
                },
              },
            ],
          }
        }}
        d_bdys={{
          ld_defss: [
            {
              type:'Pck',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt: false,
              state:'s_it10b21k',
              pfx:'バインダ',
              ld_itemss: global.c?.state.sld_im10ss,
              onCls: null,
              onChg: global.c?._onChgIt10b21k,
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt:false,
              state:'s_it10i410',
              pfx:'顧客名',
              b_mln:false,
              onChg: null,
            },
/*
            {
              type:'Pck',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt:false,
              state:'s_it20s110',
              pfx:'入席状況', // 接客状況
              ld_itemss: [
                {key:'-1', pfx: '顧客情報未確認'}, // 未接客
                {key:'0', pfx: '入席前'}, // 未接客
                {key:'10', pfx: '入席中'}, // 接客中
                {key:'20', pfx: '退席済'}, // 接客済
              ],
              b_setValOnChg:false,
              onCls:null,
              onChg:null,
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt:false,
              state:'s_it20d110',
              pfx:'入席日時', // 接客開始日時
              b_mln:false,
              onChg: null,
              o_stlVal: _d => {
                return _d.val.substr(0,16)
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt:false,
              state:'s_it20d120',
              pfx:'退席日時', // 接客終了日時
              b_mln:false,
              onChg: null,
              o_stlVal: _d => {
                return _d.val.substr(0,16)
              },
            },
            {
              type: 'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt: false,
              state: 's_it10i210',
              pfx: 'ワンドリンクサービス数',
              onCls: null,
            },
            {
              type: 'Pck',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt: false,
              state: 's_it10i220',
              pfx: 'サービス#2',
              ld_itemss: [
                  {key:'0', pfx: 'なし'},
                  {key:'10', pfx: 'あり'},
              ],
              onCls:null,
            },
            {
              type: 'Pck',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt: false,
              state: 's_it10i2a0',
              pfx: 'チャージ割引',
              ld_itemss: [
                {key:'0', pfx: 'チャージあり'},
                {key:'10', pfx: 'チャージなし'},
              ],
              onCls:null,
            },
            {
              type: 'Pck',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt: false,
              state: 's_it10i2b0',
              pfx: '消費税割引',
              ld_itemss: [
                {key:'0', pfx: '消費税あり'},
                {key:'10', pfx: '消費税なし'},
              ],
              onCls:null,
            },
*/
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt: false,
              state:'s_it10c310',
              pfx:'備考',
              b_mln:true,
              onChg:null,
            },
            {
              type: 'Btns',
              b_vsb: (global.c?.state.sgcn_pageTab == 1 && bf.f(global.c?.state.s_it10b21k)) ? true : false,
              ld_defss: [
                {
                  pfx: '入席',　// 接客開始
                  b_vsb: (global.c?.state.s_it20s110 == '0') ? true : false,
                  onPrs: global.c?._onPrsStt,
                  stlBtn: {
                    width: ic.gn_btnWLrg * 1.5,
                  },
                  stlPfx: {
                  },
                },
                {
                  b_vsb: true,
                  pfx: '退席', // 接客終了
                  b_vsb: (global.c?.state.s_it20s110 == '10') ? true : false,
                  onPrs: global.c?._onPrsEnd,
                  stlBtn: {
                    width: ic.gn_btnWLrg * 1.5,
                  },
                  stlPfx: {
                  },
                },
                {
                  pfx: '再入席', // 接客再開
                  b_vsb: (global.c?.state.s_it20s110 == '20' && global.c?.state.s_it10s110 != '20' && global.c?.state.sb_qr == true) ? true : false,
                  onPrs: global.c?._onPrsReStt,
                  stlBtn: {
                    width: ic.gn_btnWLrg * 1.5,
                  },
                  stlPfx: {
                  },
                },
              ],
              stlCta: {
                marginTop: ic.gn_mgnLrg,
                marginBottom: ic.gn_mgnLrg,
              },
            },
            {
              type: 'Btns',
              b_vsb: (global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName] == 'show' && global.c?.state.sgcn_pageTab == 1 && bf.f(global.c?.state.s_it10b21k)) ? true : false,
              ld_defss: [
                {
                  pfx: 'SOS発信',
                  b_vsb: (global.c?.state.s_it20s110 == '10' && global.c?.state.s_it10s210 != '10') ? true : false,
                  onPrs: global.c?._onPrsSosStt,
                  stlBtn: {
                    width: ic.gn_btnWLrg * 1.5,
                  },
                  stlPfx: {
                  },
                },
                {
                  pfx: 'SOS解除',
                  b_vsb: (global.c?.state.s_it20s110 == '10' && global.c?.state.s_it10s210 == '10') ? true : false,
                  onPrs: global.c?._onPrsSosEnd,
                  stlBtn: {
                    width: ic.gn_btnWLrg * 1.5,
                  },
                  stlPfx: {
                  },
                },
              ],
              stlCta: {
                marginTop: ic.gn_mgnLrg * 5,
              },
            },
            {
              type:'Msg',
              b_vsb: (global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName] == 'show' && global.c?.state.sgcn_pageTab == 1 && bf.f(global.c?.state.s_it10b21k)) ? true : false,
              pfx: (global.c?.state.s_it10s210 == '10') ? '（SOS発信中）' : '',
              stlCta: {
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: ic.gn_mgnLrg,
              },
            },
            {
              type:'Pck',
              b_vsb: (global.c?.state.sgcn_pageTab == 3) ? true : false,
              b_edt:false,
              state:'s_it10i110', // バインダ選択時に、顧客情報に紐づくコースを反映
              pfx:'コース',
//              ld_itemss: global.c?.state.sld_cm50ss1,
              ld_itemss: global.c?.state.sld_cm50ss,
              onCls:null,
              onChg:null,
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 3) ? true : false,
              b_edt:false,
              state:'s_it10d110',
              pfx:'開始時刻',
              b_mln:false,
              onChg: null,
              stlLbl: {
              fontSize: ic.gn_fontSizeNrm * 1.05,
              },
              stlInp: {
                paddingTop: 0,
                paddingBottom: 0,
                fontSize: ic.gn_fontSizeNrm * 1.3,
              },
              stlCta: {
                marginTop: 0,
                marginBottom: 0,
              },
              o_stlVal: _d => {
                return _d.val.substr(11,5)
              },
            },
            {
              type: 'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 3) ? true : false,
              b_edt: false,
              state:'s_dsp00',
              pfx: '終了時刻 / 支払総額 ※登録・反映後に更新',
              b_mln: false,
              onChg: null,
              stlLbl: {
                fontSize: ic.gn_fontSizeNrm * 1.05,
              },
              stlInp: {
                paddingTop: 0,
                paddingBottom: 0,
                fontSize: ic.gn_fontSizeNrm * 1.3,
              },
              stlCta: {
                marginTop: 0,
                marginBottom: 0,
              },
            },
            {
              type: 'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 3) ? true : false,
              b_edt: false,
              state:'s_dsp30',
              pfx: '終了時刻 / 支払総額 （30分延長）',
              b_mln: false,
              onChg: null,
              stlLbl: {
                fontSize: ic.gn_fontSizeNrm * 1.05,
              },
              stlInp: {
                paddingTop: 0,
                paddingBottom: 0,
                fontSize: ic.gn_fontSizeNrm * 1.3,
              },
              stlCta: {
                marginTop: 0,
                marginBottom: 0,
                backgroundColor: ic.g_ccdOP,
                borderTopLeftRadius: ic.gn_mgnNrm,
                borderTopRightRadius: ic.gn_mgnNrm,
                borderBottomLeftRadius: ic.gn_mgnNrm,
                borderBottomRightRadius: ic.gn_mgnNrm,
              },
            },
            {
              type: 'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 3) ? true : false,
              b_edt: false,
              state:'s_dsp60',
              pfx: '終了時刻 / 支払総額 （60分延長）',
              b_mln: false,
              onChg: null,
              stlLbl: {
                fontSize: ic.gn_fontSizeNrm * 1.05,
              },
              stlInp: {
                paddingTop: 0,
                paddingBottom: 0,
                fontSize: ic.gn_fontSizeNrm * 1.3,
              },
              stlCta: {
                marginTop: 0,
                marginBottom: 0,
                backgroundColor: ic.g_ccdYP,
                borderTopLeftRadius: ic.gn_mgnNrm,
                borderTopRightRadius: ic.gn_mgnNrm,
                borderBottomLeftRadius: ic.gn_mgnNrm,
                borderBottomRightRadius: ic.gn_mgnNrm,
              },
            },
            {
              type: 'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 3) ? true : false,
              b_edt: false,
              state: 's_it10i210',
              pfx: 'ワンドリンクサービス数',
              onCls: null,
            },
            {
              type: 'Pck',
              b_vsb: (global.c?.state.sgcn_pageTab == 3) ? true : false,
              b_edt: false,
              state: 's_it10i220',
              pfx: 'サービス#2',
              ld_itemss: [
                  {key:'0', pfx: 'なし'},
                  {key:'10', pfx: 'あり'},
              ],
              onCls:null,
            },
            {
              type: 'Pck',
              b_vsb: (global.c?.state.sgcn_pageTab == 3) ? true : false,
              b_edt: false,
              state: 's_it10i2a0',
              pfx: 'チャージ割引',
              ld_itemss: [
                  {key:'0', pfx: 'チャージあり'}, // 割引なし
                  {key:'10', pfx: 'チャージなし'}, // 割引あり
              ],
              onCls:null,
            },
            {
              type: 'Pck',
              b_vsb: (global.c?.state.sgcn_pageTab == 3) ? true : false,
              b_edt: false,
              state: 's_it10i2b0',
              pfx: '消費税割引',
              ld_itemss: [
                  {key:'0', pfx: '消費税あり'}, // 割引なし
                  {key:'10', pfx: '消費税なし'}, // 割引あり

              ],
              onCls:null,
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 3) ? true : false,
              b_edt:false,
              state:'s_it10ia40',
              pfx:'割引総額',
              b_mln:false,
              onChg:null,
              b_cmm: true,
            },
            {
              type: 'Clds',
              b_vsb: (global.c?.state.sgcn_pageTab == 2) ? true : false,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit']) && global.c?.state.s_it20s110 == '10') ? true : false,
              b_spr: true,
              b_plcNewAtTop: false,
              state: 'sld_it30ss',
              pfx: '',
              ob_ftr: _d_is => { // filter
                let _b = bf.b([
                  {
                    b_when: 
                      global.c?.state.sgcd_pageCmns?.userc410 == '10' &&
                      bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit']) && 
                      bf.i(_d_is.it30t110, ['230']) == false &&
                      String(_d_is._KEY).substr(0, 3) != 'new'
                    ,
                    o_then: () => false,
                  },
                  {
                    o_else: () => true,
                  },
                ]);
                return _b;
              },
              ld_sortss: global.c?.state.sld_it30Sortss,
/*
              d_insDats: {
                it30b21k: 
                  (global.c?.state.sgc_pageName == 'iCmrDtl') ? 
                    global.c?.state.sgcd_pageCmns?.user_key 
                  : 
                    global.c?.state.sgcd_pageCmns?.cm10_key
                ,
                it30cy20: 
                  (global.c?.state.sgc_pageName == 'iCmrDtl') ? 
                    global.c?.state.sgcd_pageCmns?.user_key 
                  : 
                    global.c?.state.sgcd_pageCmns?.cm10_key
                ,
              },
*/
              d_insDats: {
                it30b21k: global.c?.state.sgcd_pageCmns?.cm10_key,
                it30cy20: global.c?.state.sgcd_pageCmns?.cm10_key,
              },
              dd_defss: {
                it30i110: {
                  type:'PckSlc',
                  b_vsb:true,
                  ob_edt: (_d_prts, _d_is) => {
                    let _b = bf.b([
                      {
                        b_when: 
                          bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit']) && 
                          bf.i(_d_is.it30t110, ['230']) == false
                        ,
                        o_then: () => true
                      },
                      {
                        b_when: 
                          bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit']) && 
                          bf.i(_d_is.it30t110, ['230']) == true &&
                          bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['90', '80']) == true
                        ,
                        o_then: () => true
                      },
                      {
                        b_when: 
                          bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit']) && 
                          bf.i(_d_is.it30t110, ['230']) == true &&
                          bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['10']) == true &&
//                          bf.n(global.c?.state.sgcd_pageCmns?.user_key) == bf.n(_d_is.it30b21k)
                          bf.n(global.c?.state.sgcd_pageCmns?.cm10_key) == bf.n(_d_is.it30b21k)
                        ,
                        o_then: () => true
                      },
                      {
                        o_else: () => false
                      },
                    ]);
                    return _b;
                  },
                  pfx:'商品',
                  ld_itemss: global.c?.state.sld_cm50ss2,
                  onChg: ip._onChgIt30i110,
/*
                  stlLbl: {
                    fontSize: ic.gn_fontSizeNrm * 1.05,
                  },
                  stlPfx: {
                    paddingTop: 0,
                    paddingBottom: 0,
                    fontSize: ic.gn_fontSizeNrm * 1.3,
                  },
                  stlCta: {
                    marginTop: 0,
                    marginBottom: 0,
                  },
*/
                },
                it30i220: {
                  type:'Inp',
                  b_vsb:true,
                  ob_edt: (_d_prts, _d_is) => {
                    let _b = bf.b([
                      {
                        b_when: 
                          bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit']) && 
                          bf.i(_d_is.it30t110, ['230']) == false
                        ,
                        o_then: () => true
                      },
                      {
                        b_when: 
                          bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit']) && 
                          bf.i(_d_is.it30t110, ['230']) == true &&
                          bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['90', '80']) == true
                        ,
                        o_then: () => true
                      },
                      {
                        b_when: 
                          bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit']) && 
                          bf.i(_d_is.it30t110, ['230']) == true &&
                          bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['10']) == true &&
//                          bf.n(global.c?.state.sgcd_pageCmns?.user_key) == bf.n(_d_is.it30b21k)
                          bf.n(global.c?.state.sgcd_pageCmns?.cm10_key) == bf.n(_d_is.it30b21k)
                        ,
                        o_then: () => true
                      },
                      {
                        o_else: () => false
                      },
                    ]);
                    return _b;
                  },
                  pfx:'数量 ※数値のみ',
                  b_mln:false,
                  onBlur: ip._onBlurIt30i220,
                  kbdType: 'numeric',
/*
                  stlLbl: {
                    fontSize: ic.gn_fontSizeNrm * 1.05,
                  },
                  stlInp: {
                    paddingTop: 0,
                    paddingBottom: 0,
                    fontSize: ic.gn_fontSizeNrm * 1.3,
                  },
                  stlCta: {
                    marginTop: 0,
                    marginBottom: 0,
                  },
*/
                },
                dummy2: {
                  type:'Inp',
                  b_vsb:true,
                  b_edt:false,
                  pfx:'税抜額（税抜単価）',
                  b_mln:false,
                  b_cmm: false,
/*
                  stlLbl: {
                    fontSize: ic.gn_fontSizeNrm * 1.05,
                  },
                  stlInp: {
                    paddingTop: 0,
                    paddingBottom: 0,
                    fontSize: ic.gn_fontSizeNrm * 1.3,
                  },
                  stlCta: {
                    marginTop: 0,
                    marginBottom: 0,
                  },
*/
                  o_ini: (_d_prts, _d_is) => {
                    let _ini = '{}（{}）'.f(
                      bf.myCM_cnv('cmm', _d_is.it30i230 || '0'),
                      bf.myCM_cnv('cmm', _d_is.it30i210 || '0'), 
                    );
                    return _ini;
                  }
                },
                it30b21k: {
                  type:'Pck',
                  b_vsb:true,
                  b_edt: 
                    (
                      bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit']) && 
                      bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['90', '80'])
                    ) ? true : false
                  ,
                  pfx:'登録者',
//                  ini: global.c?.state.sgcd_pageCmns?.user_key,
                  ld_itemss: global.c?.state.sld_cm10ss,
                  onChg: null,
/* 
                  stlLbl: {
                    fontSize: ic.gn_fontSizeNrm * 1.05,
                  },
                  stlPfx: {
                    paddingTop: 0,
                    paddingBottom: 0,
                    fontSize: ic.gn_fontSizeNrm * 1.3,
                  },
                  stlCta: {
                    marginTop: 0,
                    marginBottom: 0,
                  },
*/
                },
                dummy1: {
                  type: 'Clds',
                  ob_vsb: (_d_prts, _d_is) => {
                    let _b = bf.b([
                      {
                        b_when: bf.i(_d_is.it30t110, ['230']),
                        o_then: () => true,
                      },
                      {
                        o_else: () => false,
                      },
                    ]);
                    return _b
                  },
                  b_edt: true,
                  b_spr: false,
                  b_plcNewAtTop: false,
                  state: 'sld_it31ss',
                  prtFld: 'it31b21k', // it30_key
                  o_pfx: _d_is => {
                    let _pfx = bf.b([
                      {
                        b_when: 
                          bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['90', '80'])
                        ,
                        o_then: () => '関与者／関与度',
                      },
                      {
                        o_else: () => '関与者',
                      }
                    ]);
                    return _pfx;
                  },
                  stlLbl: {
                    fontSize: ic.gn_fontSizeNrm * 1.05,
                  },
                  ob_newLine: _d_is => {
                    let _n_cnt = ip.get_cntIt31User({it30_key:_d_is._KEY});                    
                    let _b = bf.b([
                      {
                        b_when: 
                          bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit']) &&
                          bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['90', '80'])
                        ,
                        o_then: () => true,
                      },
                      {
                        b_when: 
                          bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit']) &&
                          bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['10']) &&
                          _n_cnt == 0
                        ,
                        o_then: () => true,
                      },
                      {
                        o_else: () => false,
                      },
                    ]);
                    return _b; // シャンパンのみ複数登録可能
                  },
                  d_insDats: {
                    it31i110: '1',
                  },
                  b_oneTtl: true,
                  dd_defss: {
                    it31b31k: {
                      type: 'Pck',
                      ob_vsb: (_d_prts, _d_is) => {
                        let _b = bf.b([
                          {
                            b_when: bf.i(_d_prts.it30t110, ['230']),
                            o_then: () => true,
                          },
                          {
                            o_else: () => false,
                          },
                        ]);
                        return _b;
                      },
                      b_dlt: true,
                      ob_edt: (_d_prts, _d_is) => {
                        let _b = bf.b([
                          {
                            b_when:
                              bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit']) &&
                              bf.i(_d_prts.it30t110, ['230']) == true &&
                              (
                                bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['90', '80']) ||
//                                bf.n(_d_is.it31b31k) == bf.n(global.c?.state.sgcd_pageCmns?.user_key) ||
                                bf.n(_d_is.it31b31k) == bf.n(global.c?.state.sgcd_pageCmns?.cm10_key) ||
                                bf.f(_d_is) == false
                              )
                            ,
                            o_then: () => true,
                          },
                          {
                            o_else: () => false,
                          },
                        ]);
                        return _b;
                      },
                      pfx: '',
                      phd: '関与者を登録ください',
                      ld_itemss: global.c?.state.sld_cm10ss,
                      ini: null,
                      ctrVal: null,
                      onChg: null,
                      oo_rlcFldPrs: (_d_prts, _d_is) => { // replace fld press
                        if (bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['10']) != true) return null; // キャストの場合のみ置き換え
                        return _d_ids => {
                          let _n_cnt = ip.get_cntIt31User({it30_key:_d_is.it31b21k});
                          if (_n_cnt > 0) return; // 既存データが存在する場合は追加しない
                          global.c?.setState({
                            sld_it31ss: bf.p( global.c?.state.sld_it31ss, _next => {
                              _next.push({
                                _KEY: 'new',
//                                it31b31k: global.c?.state.sgcd_pageCmns?.user_key,
                                it31b31k: global.c?.state.sgcd_pageCmns?.cm10_key,
                                b_dlt: false,
                                b_ups: true,
                                it31b21k: _d_prts._KEY,
                                it31i110: '1',
                              })
                            }),
                          })
                        };
                      },
/*
                      stlLbl: {
                        fontSize: ic.gn_fontSizeNrm * 1.05,
                      },
                      stlPfx: {
                        paddingTop: 0,
                        paddingBottom: 0,
                        fontSize: ic.gn_fontSizeNrm * 1.3,
                      },
                      stlCta: {
                        marginTop: 0,
                        marginBottom: 0,
                      },
*/
                    },
                    it31i110: {
                      type: 'Inp',
                      ob_vsb: (_d_prts, _d_is) => {
                        let _b = bf.b([
                          {
                            b_when: 
                              bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['90', '80']) &&
                              bf.i(_d_prts.it30t110, ['230']) &&
                              bf.f(_d_is) == true
                            ,
                            o_then: () => true,
                          },
                          {
                            o_else: () => false,
                          },
                        ]);
                        return _b;
                      }, 
                      b_edt: bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit']),
                      pfx: '',
                      phd: '関与度を数値で入力ください',
                      onChg: null,
                      b_mln:false,
/*
                      stlLbl: {
                        fontSize: ic.gn_fontSizeNrm * 1.05,
                      },
                      stlInp: {
                        paddingTop: 0,
                        paddingBottom: 0,
                        fontSize: ic.gn_fontSizeNrm * 1.3,
                      },
                      stlCta: {
                        marginTop: 0,
                        marginBottom: 0,
                      },
*/
                    },
                  },
                },

                dummy3: {
                  type:'Inp',
                  b_vsb:true,
                  b_edt:false,
                  pfx:'更新者／更新日時',
                  o_ini: (_d_prts, _d_is) => {
                    let _d_cm10s = bf.myCM_get_dct({
                      mode: 'items', 
                      ld_itemss: global.c?.state.sld_cm10ss, 
                      fld:'key', val:bf.n(_d_is.it30cy20)
                    });
                    let _pfx = '';
                    if (bf.f(_d_cm10s)) {
                      _pfx = _d_cm10s.pfx;
                    };
                    let _date = ''
                    if (bf.f(_d_is.it30cy10)) {
                      _date = _d_is.it30cy10.substr(0,16);
                    };
                    let _ini = '{}　{}'.f(
                      _pfx,
                      _date,
                    );
                    return _ini;

                  },
                  onChg: null,
/*
                  stlLbl: {
                    fontSize: ic.gn_fontSizeNrm * 1.05,
                  },
                  stlInp: {
                    paddingTop: 0,
                    paddingBottom: 0,
                    fontSize: ic.gn_fontSizeNrm * 1.3,
                  },
                  stlCta: {
                    marginTop: 0,
                    marginBottom: 0,
                  },
*/
                },
              },
            },
          ],
        }}
        d_tops={{
          n_h: ic.gn_fontSizeNrm + ic.gn_bdrWNrw * 2 + ic.gn_mgnNrm * 4,
          ld_defss: [
            {
              type: 'Btns',
              b_vsb: true,
              ld_defss: [
                {
                  pfx: '基本情報',
                  b_vsb: true,
                  b_rvs: (global.c?.state.sgcn_pageTab == 1) ? false : true,
                  onPrs: () => {
                    global.c?.$onPrsTab({n_tab: 1});
                    global.c?._chk_it10d120();
                  },
                  stlBtn: {
                    width: ic.gn_btnWLrg,
                  },
                  stlPfx: {
                  },
                },
                {
                  pfx: 'コース情報',
                  b_vsb: true,
                  b_rvs: (global.c?.state.sgcn_pageTab == 3) ? false : true,
                  onPrs: () => {
                    global.c?.load()
                    .then(() => {
                      global.c?.$onPrsTab({n_tab: 3});
                      global.c?._chk_it10d120();
                    });
                  },
                  stlBtn: {
                    width: ic.gn_btnWLrg,
                  },
                  stlPfx: {
                  },
                },
                {
                  pfx: '注文情報',
                  b_vsb: true,
                  b_rvs: (global.c?.state.sgcn_pageTab == 2) ? false : true,
                  onPrs: () => {
                    global.c?.$onPrsTab({n_tab: 2});
                    global.c?._chk_it10d120();
                  },
                  stlBtn: {
                    width: ic.gn_btnWLrg,
                  },
                  stlPfx: {
                  },
                },
              ],
              stlCta: {
                marginTop: ic.gn_mgnLrg,
                marginBottom: ic.gn_mgnLrg,
              },
            },
          ],
        }}
      />
      <ce.MsgMdl
        key={-2}
        d_msgs={{
          pfx: '終了時刻{}分前を過ぎました。\n延長またはドリンクの確認をお願いします。'.f(global.c?.state.s_cm2ii110),
          stlPfx: {
            fontSize: ic.gn_fontSizeNrm * 1.3,
          },
        }}
      />
      </this.$onChg>
    );
  }

}
